<div class="header-bar">
  <div class="title">{{ 'PROFILE.PREFERENCES' | translate }}</div>
  <mat-icon
    class="close-icon"
    (click)="close()"
    >close</mat-icon
  >
</div>
<div class="container">
  <div class="side-bar">
    <ul>
      @for (item of panelItems; track $index) {
        <li
          [ngStyle]="{ 'background-color': currentSelect === item ? highlightedColorLeftSideMenuItem : '' }"
          appNavBrandingColor
          [isActiveBrandingColor]="currentSelect === item"
          (click)="currentSelect = item"
          [ngClass]="{ 'is-active': currentSelect === item }"
          (mouseenter)="currentHover = item"
          (mouseleave)="currentHover = ''">
          <img
            [src]="
              'icons/' +
                item.replaceAll(' ', '_').toLowerCase() +
                (currentHover === item || currentSelect === item ? '_hover_16dp.svg' : '_16dp.svg') | assetUrl
            "
            height="16"
            width="16"
            alt="" />
          <div>{{ 'PREF_NAV.' + item.replaceAll(' ', '_').toUpperCase() | translate }}</div>
        </li>
      }
    </ul>
    @if (debugVersion) {
      <div class="item debug-container">
        <div class="text-center">
          <span> {{ 'PREF_NAV.VERSION' | translate }}: </span>
          <span>{{ debugVersion }} </span>
        </div>
        <img
          [src]="'icons/update_24dp.svg' | assetUrl"
          height="24"
          width="24"
          class="update-btn"
          (click)="onUpdate()"
          alt="" />
        @if (updateService.updateRejected$ | async) {
          <div class="update-badge"></div>
        }
      </div>
    }
  </div>
  <div class="settings">
    @switch (currentSelect) {
      @case (SettingType.Profile) {
        <app-profile [profile]="profile"></app-profile>
      }
      @case (SettingType.Audio) {
        <app-audio #page></app-audio>
      }
      @case (SettingType.Notifications) {
        <app-notification #page></app-notification>
      }
      @case (SettingType.Contacts) {
        <app-contacts #page></app-contacts>
      }
      @case (SettingType.Video) {
        <app-video #page></app-video>
      }
      @case (SettingType.AnsweringRules) {
        <app-answering-rules
          #page
          (cancelChanges)="currentSelect = SettingType.Profile"></app-answering-rules>
      }
      @case (SettingType.BlockedNumbers) {
        <app-blocked-numbers #page></app-blocked-numbers>
      }
      @case (SettingType.Calling) {
        <app-calling #page></app-calling>
      }
      @case (SettingType.CallRecordings) {
        <app-call-recordings #page></app-call-recordings>
      }
      @case (SettingType.MusicOnHold) {
        <app-music-on-hold #page></app-music-on-hold>
      }
      @case (SettingType.Integrations) {
        <app-integrations #page></app-integrations>
      }
      @case (SettingType.Voicemail) {
        <app-voicemail
          (voicemailSettingsSaved)="currentSelect = SettingType.Profile"
          #page></app-voicemail>
      }
      <!--
      @case (SettingType.Headset) {
        <app-hid #page></app-hid>
      } -->
      @case (SettingType.Apps) {
        <app-apps #page></app-apps>
      }
      @case (SettingType.SpeedDial) {
        <app-speed-dial-preferences></app-speed-dial-preferences>
      }
      @case (SettingType.KeyboardShortcuts) {
        <app-keyboard-shortcuts #page></app-keyboard-shortcuts>
      }
      @default {
        <div class="settings-placeholder">
          <span>{{ 'CONTACT_PREFERENCES.SELECT_PREFERENCE' | translate }}</span>
        </div>
      }
    }
    @if (
      currentSelect !== SettingType.BlockedNumbers &&
      currentSelect !== SettingType.Contacts &&
      currentSelect !== SettingType.Integrations &&
      currentSelect !== SettingType.Voicemail &&
      currentSelect !== SettingType.AnsweringRules &&
      currentSelect !== SettingType.Apps &&
      currentSelect !== SettingType.SpeedDial &&
      currentSelect !== SettingType.KeyboardShortcuts
    ) {
      @if (currentPage) {
        <div class="flex justify-content-end align-center bottom-bar">
          <button
            class="cancel-button"
            (click)="currentSelect = SettingType.Profile"
            mat-button
            type="button"
            appBrandingColor
            [brandingField]="BrandingField.FieldColorFontIconsListAreaItems"
            styleType="color">
            {{ 'CONTACT_PREFERENCES.CANCEL' | translate }}
          </button>
          <button
            [disabled]="currentPage.disabled"
            color="primary"
            mat-raised-button
            class="m-l-12 save-button"
            (click)="save(currentPage)"
            type="button"
            appBrandingColor
            [brandingField]="BrandingField.FieldColorFontIconsListAreaItems">
            @if (currentPage.loading) {
              <mat-spinner diameter="24"></mat-spinner>
            } @else {
              <span>{{ 'CONTACT_PREFERENCES.SAVE' | translate }}</span>
            }
          </button>
        </div>
      }
    }
  </div>
</div>
